var alignment_rtlignore_default = {
  "alignLeft": "-rZz5",
  "textWrapNowrap": "fhG77",
  "alignRight": "o-URt",
  "alignCenter": "hzF9x",
  "sizeFullWidth": "Kv8GU",
  "renderedInTable": "zqG51",
  "sizeOriginal": "hxjok",
  "sizeContent": "_7eyu6",
  "sizeSmall": "x7BpU",
  "sizeSmallCenter": "Yn2wi",
  "flex": "BdKbL",
  "LEFT": "RpS-8",
  "CENTER": "NPRAr",
  "RIGHT": "nZrew",
  "AUTO": "eK8mK",
  "JUSTIFY": "HbLYy"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
